export type MyIpChangeReason = 'binding' | 'content';

const listeners = new Set<(reason: MyIpChangeReason) => void>();

/** 只发送失效原因，不在全局保存任何角色内容；订阅方按当前登录空间重新鉴权读取。 */
export function notifyMyIpChanged(reason: MyIpChangeReason = 'binding') {
  listeners.forEach((listener) => listener(reason));
}

/** 页面和资产库共用刷新通知，卸载时必须解除订阅。 */
export function subscribeMyIpChanged(listener: (reason: MyIpChangeReason) => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
